import { render, staticRenderFns } from "./advSearchAgeFilter.vue?vue&type=template&id=39aae28f&scoped=true&"
import script from "./advSearchAgeFilter.vue?vue&type=script&lang=js&"
export * from "./advSearchAgeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39aae28f",
  null
  
)

export default component.exports